import React, {FC, useContext, useEffect} from 'react'
import styles from './Icon.module.css'
import cn from 'classnames'
import {IconType} from './IconType'
import {IconCache} from '../../../hocs/icon/IconCache'

type IconCollection = 'exchange' | 'ui' | 'currency' | 'language' | 'wallet'

type Props = {
  className?: string
  icon: IconType | string
  collection?: IconCollection
  // Only for currency and exchange collections
  type?: 'theme' | 'color' | 'white' | 'dark'
}

function isValidIconSvg(data: string): boolean {
  return !!data && data.trimLeft().toLowerCase().startsWith('<svg');
}

export const Icon: FC<Props> = ({
  className,
  icon,
  collection = 'ui',
  type = 'theme'
}) => {
  const iconCache = useContext(IconCache)
  const actualIcon = collection === 'currency' ? icon.toLowerCase() : icon
  const iconUrl = `/icons/${collection}/${actualIcon}.svg`
  const iconHtml = iconCache.icons[iconUrl]

  useEffect(() => {
    if (
      !iconHtml &&
      iconCache.loading.indexOf(iconUrl) === -1 &&
      iconCache.startLoadingIcon(iconUrl)
    ) {
      fetch(iconUrl)
        .then((l) => l.text())
        .then((icon) => {
          if (isValidIconSvg(icon)) {
            iconCache.cacheIcon(iconUrl, icon)
          }
        })
    }
  }, [icon, collection])

  return (
    <div
      className={cn(styles.root, styles[collection], styles[type], className)}
      dangerouslySetInnerHTML={{ __html: iconHtml || '' }}
    />
  )
}
